import { MarkdownContent } from "~components";
import type { OnboardingConfiguration } from "~onboarding/utils";
import { translate } from "~utils";

/***** Types *****/
type RejectionPageBaseProps = Pick<OnboardingConfiguration, "rejectionMessageMarkdown">;

/***** Component *****/
export function RejectionPageBase(props: RejectionPageBaseProps) {
  const { rejectionMessageMarkdown } = props;

  /*** Render ***/
  return (
    <div css={{ padding: "24px 16px" }}>
      <h3>Welcome</h3>
      <p>{translate("ONBOARDING_REJECTION_MESSAGE")}</p>
      {rejectionMessageMarkdown && <MarkdownContent body={rejectionMessageMarkdown} />}
      <p>{translate("ONBOARDING_REJECTION_CONTACT_SUPPORT_MESSAGE")}</p>
    </div>
  );
}
